import { useDispatch } from "react-redux";

import { Case } from "pwapi";

import { UserLocation } from "custom-models";

import { updatePatientAddress } from "shared/actions/admin/adminPatientActions";
import { CaseAdminDetail } from "shared/reducers/admin/adminCaseReducer";

import AdminPanel from "components/admin/adminPanel/AdminPanel";
import HalfScreenPanel from "components/admin/editPanels/halfScreenEditPanel/HalfScreenPanel";
import DjangoLink from "components/DjangoLink";

import LocationForm from "./LocationForm";

type LocationPanelProps = {
  accessionCompleted?: string | null;
  adminCase: CaseAdminDetail;
  billingType?: Case.billing_type | null;
  setEditLocation: Function;
  title: string;
  location: UserLocation;
  canUpdateLocation?: boolean;
  thirdPartyRequireLocationFields?: boolean;
};

const LocationPanel = ({
  accessionCompleted,
  adminCase,
  billingType,
  setEditLocation,
  title,
  location,
  canUpdateLocation = true,
  thirdPartyRequireLocationFields = false,
}: LocationPanelProps) => {
  const dispatch = useDispatch();

  const handleOnClose = () => {
    setEditLocation(null);
  };

  const handleOnSubmit = (values: UserLocation) => {
    values?.id && dispatch(updatePatientAddress(values, handleOnClose));
  };

  return (
    <HalfScreenPanel onClose={handleOnClose}>
      <div className="HalfScreen__container">
        <AdminPanel
          title={{
            prefix: `Location #${location?.id}`,
            main: title,
          }}
          djangoLink={
            <DjangoLink
              route={`pathology/location/${location?.id}/change/`}
              title="Django Location Access"
            />
          }
        >
          <LocationForm
            accessionCompleted={accessionCompleted}
            adminCase={adminCase}
            billingType={billingType}
            location={location}
            onClose={handleOnClose}
            onSubmit={handleOnSubmit}
            disableSubmit={!canUpdateLocation}
            thirdPartyRequireLocationFields={thirdPartyRequireLocationFields}
          />
        </AdminPanel>
      </div>
    </HalfScreenPanel>
  );
};

export default LocationPanel;
